import React from 'react'
import styled from 'styled-components/macro'
import { theme, ifProp } from 'styled-tools'
import { media } from '../../../ui/rwd'
import {
  Modal as ReactstrapModal,
  ModalBody as ReactstrapModalBody,
  ModalFooter as ReactstrapModalFooter
} from 'reactstrap'
import CloseButton from './../../../components/shared/CloseButton/CloseButton'

const ModalClose = styled(CloseButton)`
  right: 15px;
  left: auto;
`

const Modal = styled(ReactstrapModal)`
  &.modal-lg {
    ${media.sm`
     max-width:650px;
     margin-top: 3em;
  `}

    ${media.md`
   max-width:800px;
  `}
  }

  &.modal-sm {
    margin-top: 3em;
  }
  z-index: 10;
  transform: none;
`
const ModalBody = styled(({ className, children }) => (
  <ReactstrapModalBody className={className}>{children}</ReactstrapModalBody>
))`
  &.modal-body {
    padding: ${ifProp('noStyle', '0', '1rem')};
    background: ${ifProp('noStyle', theme('seashell'), theme('white'))};
    border-radius: 8px;
    ${media.sm`
    padding: ${ifProp('noStyle', '0', '2rem')};
  `}
  }
`
const ModalFooter = styled(ReactstrapModalFooter)`
  &.modal-footer {
    padding-top: 2rem;
    padding-bottom: 5rem;
    ${media.sm`
    padding-bottom: 2rem;
  `}
  }
`

export { Modal, ModalClose, ModalBody, ModalFooter }
